









































import { editFactory } from '@/main/pages';
import { Vozidlo } from '@/modules/kartoteka/vozidlo';

import { NAME as zapujckyName } from '../zapujcka/constants';
import { NAME, DEPENDENT_TABLES } from './constants';
import Poznamka from './components/Poznamka.vue';
import ZakladniInformace from './components/ZakladniInformace.vue';
import { types } from './store/types';
import { store } from './store/edit';

export default editFactory(NAME, store).extend({
	components: {
		VozidloSelect: Vozidlo.components.Select,
		Poznamka,
		ZakladniInformace,
	},
	data() {
		return {
			dependencies: DEPENDENT_TABLES,
			zapujckyName,
			tabItems: {
				ZakladniInformace: { id: 'ZakladniInformace', labelKey: 'VozidlopaTab0' },
				Poznamka: { id: 'Poznamka', labelKey: 'VozidlopaTab1' },
				Prehledy: { id: 'Prehledy', labelKey: 'regdtPrehledy' },
			},
		};
	},
	computed: {
		mutationsMappers() {
			return {
				vozidlo: `${this.storeUri}/${types.mutations.VOZIDLA_PUJCOVNY_VOZIDLO_MAPPER}`,
			};
		},
		actionsMappers(): Record<string, string> {
			return {
				vozidlo: `${this.storeUri}/${types.actions.VOZIDLO_SELECT_ZMENA}`,
			};
		},
		localizedDruh() {
			return this.LocalizePopisostatni('cmdVozidlopa');
		},
		vozidlo() {
			return this.$store.state.Pujcovna.VozidloPujcovnaEdit.Edit;
		},
		zapujcka() {
			return zapujckyName;
		},
	},
});
